import React, { Fragment, useEffect, useState } from "react";

const RightSideBarMenu = ({
  sectionData,
  onSectionClick,
  selectedSection,
  selectedRole,
}) => {
  const section = sectionData?.filter(
    (section) =>
      section.role.find((role) => role === selectedRole) === selectedRole
  )[selectedSection];

  const headingStyle = { cursor: "pointer" };

  const handleScroll = (sectionId) => {
    const element = document.getElementById(sectionId);
    setActiveSection(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    setActiveSection("");
    const observerOptions = {
      root: null,
      rootMargin: "0px 0px -80% 0px",
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, observerOptions);

    const sectionElements = document.querySelectorAll(".observe-documentation");
    sectionElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      sectionElements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, [sectionData, selectedSection, selectedRole]);

  return (
    <div className="h-100 border-start">
      <div className="row h-100">
        <div className="bg-white rounded p-4 min-vh-100 d-flex justify-content-between flex-column">
          <div>
            <a className="text-decoration-none text-black d-flex align-items-center ms-3 mt-2">
              <span className="ms-1 fs-5">Content</span>
            </a>
            <hr className="bg-black" />
            <ul className="nav nav-pills flex-column">
              {section?.headings?.map((heading, headingIndex) => (
                <Fragment key={headingIndex}>
                  <h6
                    className={
                      activeSection === heading.id ? "text-primary" : ""
                    }
                    style={headingStyle}
                    onClick={() =>
                      handleScroll(
                        // `${section.section.split(" ")[0]}-${
                        //   heading.heading.split(" ")[0]
                        // }`
                        heading.id
                      )
                    }
                  >
                    {heading?.heading}
                  </h6>
                  <div className="mb-3">
                    {
                      // heading?.subHeadings?.length > 1 &&
                      heading?.subHeadings?.map(
                        (subHeading, subHeadingIndex) => (
                          <h6
                            key={subHeadingIndex}
                            className={`ms-3 ${
                              activeSection === subHeading.id
                                ? "text-primary"
                                : ""
                            }`}
                            style={headingStyle}
                            onClick={() =>
                              handleScroll(
                                // `${section.section.split(" ")[0]}-${
                                //   subHeading.subHeading.split(" ")[0]
                                // }`
                                subHeading.id
                              )
                            }
                          >
                            {subHeading.subHeading}
                          </h6>
                        )
                      )
                    }
                  </div>
                </Fragment>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightSideBarMenu;
